export const getEditingPulse = state => state.pulse.editingPulse;

export const getPulseFormInput = state => state.pulse?.formInput;
